let backend = {
  uri: process.env.REACT_APP_BACKEND_URI,   /** || "http://192.168.0.116:4000" **/
  ws: process.env.REACT_APP_WEBSOCKET_URI   /** || "ws://192.168.0.116:4000" **/
}

// The temp/new site must NOT route to the main jamit backend — it relies purely on
// REACT_APP_BACKEND_URI. This host-based override only applies to the main deployment.
if(process.env.REACT_APP_SITE_VARIANT !== 'temp' && window.location.host.includes("staging")){
  backend.uri = "https://staging.jamit.io"
  backend.ws = "wss://staging.jamit.io"
}

// if(true){ // testing purpose
//   backend.uri = "https://staging.jamit.io"
//   backend.ws = "wss://staging.jamit.io"
// }

module.exports = {
  backend
}